<template>
  <div class="body-desktop-complement">
    <div class="background"></div>
    <div class="background-overflow"></div>
    <div class="header-wrapper border-bottom">
      <h4 :class="['title', { skeleton: loading }]">
        Pedido: <span>{{ orderId }}</span>
      </h4>
    </div>
    <div class="retailer-info" :class="['display-order_date', { skeleton: loading }]">
      <p>Loja: {{ retailerName }} em {{ purchasedDate | dateFilter }}</p>
      <p>{{ products.length }} itens</p>
    </div>

    <ProductList :products="products" />

    <div class="link">
      <router-link tag="a" to="/portal" exact>Ver no Parcelex</router-link>
    </div>
  </div>
</template>

<script>
import StringMixin from '@/mixins/string';
import ProductList from './ProductList.vue';

export default {
  name: 'DesktopContainer',
  props: {
    orderId: {
      type: String,
    },
    purchasedDate: {
      type: String,
    },
    installmentNumber: {
      type: Number,
    },
    installmentNumbers: {
      type: Number,
    },
    installmentValue: {
      type: Number,
    },
    installmentDueDate: {
      type: String,
    },
    retailerName: {
      type: String,
    },
    products: {
      type: Array,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [StringMixin],
  components: {
    ProductList,
  },
};
</script>

<style lang="scss" scoped>
  @import '@/scss/__new-styles.scss';

  .skeleton {
    width: 100%;
  }
  .background {
    position: absolute;
    z-index: -1;
    top: 0;
    margin-left: -36px;

    background-color: var(--gray-100);
    height: 100vh;
    width: 442px;
  }
  .background-overflow {
    position: absolute;
    z-index: -1;
    top: 0;
    right: 0;

    background-color: var(--gray-100);
    height: 100vh;
    width: 40%;
  }
  .body-desktop-complement {
    overflow: hidden;
    overscroll-behavior: unset;

    height: calc(100vh - 98px);
    max-width: 442px;
    width: 100%;
    padding-left: 36px;
    padding-right: 36px;

    display: none;

    background-color: var(--gray-100);

    @media (min-width: $lg) {
      display: inline-block;
    }
  }
  .header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
    padding-bottom: 16px;
  }
  .title {
    @extend .body-bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;

    font-family: var(--font-family);

    span {
      font-weight: 700;
    }
  }
  .link {
    @extend .small-regular;
    font-family: var(--font-family);
    line-height: 20px;
    margin-top: 20px;

    a {
      text-decoration: none;
      -webkit-tap-highlight-color: transparent;
    }
  }
  .display-order_date {
    @extend .small-regular;
    font-family: var(--font-family);
    line-height: 20px;
    color: var(--gray-500);

    display: inline-block;

    &.skeleton {
      width: 100%;
    }
  }
  .wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;

    .skeleton {
      max-width: 100px
    }
  }
  .text {
    @extend .small-regular;
    font-family: var(--font-family);
    line-height: 20px;
  }
  .value {
    @extend .small-semi-bold;
    font-family: var(--font-family);
    line-height: 20px;
    font-weight: 600;

    &.skeleton {
      height: 20px;
    }
  }
  .border-bottom {
    border-bottom: 1px solid var(--gray-200);
  }

  .retailer-info {
    @extend .small-regular;

    display: flex;
    align-items: center;
    justify-content: space-between;

    line-height: 20px;
    color: var(--gray-700);

    margin-top: 16px;
  }
</style>
